import React, { useEffect, useState } from 'react'
import { FormControlLabel, FormGroup } from '@material-ui/core'

import * as Styled from './styles'
import { Controller } from 'react-hook-form'
import { useMemo } from 'react'
import { Box, FormHelperText } from '@mui/material'
import { CheckIcon } from '../../../../../components/storybook'

const RegisterCheckbox = ({
    options,
    disabled,
    errors,
    control,
    setValue,
    watch,
    themeColor,
}) => {

    const hasErrors = useMemo(
        () => options.find((option) => errors?.[option.name]),
        [errors, options],
    )

    let { useRegulation, useTerms, newsletter, selectAll, usePrivacyPolicy } =
        watch()

    const [errorList, setErrorList] = useState([])

    useEffect(() => {
        if (useRegulation && useTerms && newsletter && usePrivacyPolicy) {
            setValue('selectAll', true, { shouldValidate: true })
        }

        if (!useRegulation || !useTerms || !newsletter || !usePrivacyPolicy) {
            setValue('selectAll', false, { shouldValidate: true })
        }
    }, [
        usePrivacyPolicy,
        useRegulation,
        useTerms,
        newsletter,
        setValue,
        selectAll,
    ])

    useEffect(() => {
        let errorList = []
        if (errors) {
            Object.keys(errors).forEach((error) => {
                if (options.find((option) => option.name === error)) {
                    errorList.push(error)
                }
            })
        }
        setErrorList(errorList)
    }, [errors, options])

    return (
        <Styled.CustomDiv>
            <Styled.CustomFormGroup
                component="fieldset"
                disableRipple
                error={hasErrors}
            >
                <FormGroup disableRipple style={{ gap: 10 }}>
                    {options?.map((option) => (
                        <Controller
                            key={option.name}
                            render={(
                                { onChange, onBlur, value, name, ref },
                            ) => {
                                return (
                                    <FormControlLabel
                                        key={option.name}
                                        disabled={disabled}
                                        label={option.label}
                                        disableRipple
                                        onBlur={onBlur}
                                        onChange={(e) => {
                                            onChange(e.target.checked)
                                            if (name === 'selectAll') {
                                                setValue(
                                                    'useTerms',
                                                    e.target.checked,
                                                    { shouldValidate: true },
                                                )
                                                setValue(
                                                    'useRegulation',
                                                    e.target.checked,
                                                    { shouldValidate: true },
                                                )
                                                setValue(
                                                    'newsletter',
                                                    e.target.checked,
                                                    { shouldValidate: true },
                                                )
                                                setValue(
                                                    'usePrivacyPolicy',
                                                    e.target.checked,
                                                    { shouldValidate: true },
                                                )
                                            }
                                        }}
                                        checked={value}
                                        inputRef={ref}
                                        control={
                                            <Styled.CValeCheckbox
                                                icon={
                                                    <Box
                                                        sx={{
                                                            background: "#FFFFFF 0% 0% no-repeat padding-box",
                                                            border: `1px solid ${errors?.[option.name] ? "#f44336" : "#C6C6C6"}`,
                                                            borderRadius: "4px",
                                                            opacity: 1,
                                                            height: "18px",
                                                            width: "18px",
                                                        }}
                                                    />
                                                }
                                                checkedIcon={
                                                    <Box
                                                        sx={{
                                                            width: "18px",
                                                            height: "18px",
                                                            background: `${themeColor?.navigation?.buttons?.backgroundColor} 0% 0% no-repeat padding-box`,
                                                            borderRadius: "4px",
                                                            opacity: 1
                                                        }}
                                                    >
                                                        <CheckIcon color="#ffffff" size={10} />
                                                    </Box>
                                                }
                                                disableRipple
                                                themeColor={themeColor}
                                            />
                                        }
                                    />
                                )
                            }}
                            name={option.name}
                            control={control}
                        />
                    ))}
                </FormGroup>
                {errorList.length > 0 && (
                    <FormHelperText
                        error
                        sx={{
                            paddingLeft: '27px',
                            animation: `${Styled.shake} 1.4s`,
                        }}
                    >
                        Existem campos obrigatórios não preenchidos.
                    </FormHelperText>
                )}
            </Styled.CustomFormGroup>
        </Styled.CustomDiv>
    )
}

export default RegisterCheckbox
